import { SimpleGrid } from '@chakra-ui/react';

import { MonthActionCard } from '@/components/MonthActions/MonthActionCard';
import { NoEntries } from '@/components/NoEntries/NoEntries';

import { MonthAction } from '@/models/cms/MonthAction';

type MonthActionsGridProps = {
    data: MonthAction[];
};

export const MonthActionsGrid = (props: MonthActionsGridProps) => {
    const { data } = props;

    if (!data.length) {
        return <NoEntries />;
    }

    return (
        <SimpleGrid gap={4}>
            {data.map((item) => (
                <MonthActionCard key={item.id} data={item} />
            ))}
        </SimpleGrid>
    );
};
